import RequirementRow from "./RequirementRow";
import type { RequirementSection as RequirementSectionData } from "../data/requirementsData";

interface RequirementSectionProps {
  section: RequirementSectionData;
  onToggle: (id: string) => void;
}

const RequirementSection = ({ section, onToggle }: RequirementSectionProps) => {
  const done = section.rows.filter((r) => r.isAccepted === true).length;
  const total = section.rows.length;
  const isComplete = done === total;
  return (
    <div className="reqSection">
      <div className="reqSection__header">
        <span className="reqSection__icon">{section.icon}</span>
        <span className="reqSection__title">{section.title}</span>
        <span
          className={`reqSection__status${isComplete ? " reqSection__status--done" : ""}`}
        >
          {done} of {total}
        </span>
      </div>
      {section.rows.map((row) => (
        <RequirementRow
          key={row.id}
          row={row}
          isAcknowledged={row.isAccepted === true}
          onToggle={onToggle}
        />
      ))}
    </div>
  );
};

export default RequirementSection;
